function Location(latitude, longitude, elevation = 0) {
  latitude = typeof latitude === 'undefined' ? NaN : latitude;
  longitude = typeof longitude === 'undefined' ? NaN : longitude;
  elevation = typeof elevation === 'undefined' ? NaN : elevation;
  this.latitude = latitude;
  this.longitude = longitude;
  this.elevation = elevation;
}

Location.prototype = {
  /**
   * Clones the location
   * @return {Location} Clone of the location
   */
  clone: function () {
    return new Location(this.latitude, this.longitude, this.elevation);
  },

  /**
   * Compares the location
   * @param  {Location} location     Location to compare
   * @param  {float} tolerance Tolerance value for comparaison
   * @return {Boolean}           True if locaitons are equal
   */
  equals: function (location, tolerance) {
    var t = typeof tolerance !== 'undefined' ? tolerance : 0;
    if (location) {
      if (t != 0) {
        return (
          Math.abs(this.latitude - location.latitude) < t &&
          Math.abs(this.longitude - location.longitude) < t
        );
      } else {
        return (
          Math.abs(this.latitude - location.latitude) == 0 &&
          Math.abs(this.longitude - location.longitude) == 0
        );
      }
    }
    return false;
  },

  /**
   * Generates a string that represents the location.
   * @return {String} Location's coordinates in string format
   */
  toString: function () {
    var str = 'latitude: ' + this.latitude + ' longitude: ' + this.longitude;
    if (!isNaN(this.elevation)) {
      str = str + 'elevation: ' + this.elevation;
    }
    return str;
  },

  isValid: function () {
    return !(isNaN(this.latitude) || isNaN(this.longitude));
  },

  getDistance: function (location) {
    function toRad(degrees) {
      return degrees * (Math.PI / 180);
    }

    var R = 6371; // km
    var dLat = toRad(location.latitude - this.latitude);
    var dLon = toRad(location.longitude - this.longitude);
    var lat1 = toRad(this.latitude);
    var lat2 = toRad(location.latitude);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  },
};

export default Location;

export const fromArray = (coordArray) =>
  new Location(parseFloat(coordArray[0]), parseFloat(coordArray[1]));
export const fromString = (coordString) => coordString && fromArray(coordString.split(','));
